import type { ColDef, ICellRendererParams, ValueGetterParams } from 'ag-grid-enterprise'
import type { ReactElement } from 'react'
import type { Menu } from '~/components/ActionMenu'
import type { IAppBuild } from '~/types/build'

import ActionMenu from '~/components/ActionMenu'
import BadgeCellRenderer from '~/components/CellRenderers/BadgeCellRenderer'
import DeviceTypeCellRenderer from '~/components/CellRenderers/DeviceTypeCellRenderer'
import TextCellRenderer from '~/components/CellRenderers/TextCellRenderer'
import { capitalize } from '~/utils/string'
import { actionsColDef, badgeColDef, dateIsoColDef, textColDef } from '~/utils/table'

const ActionsCellRenderer = ({ context, data }: ICellRendererParams<IAppBuild>): ReactElement => {
  if (data) {
    const { handleEdit } = context

    const menu: Menu = {
      actions: [
        {
          action: handleEdit(true, data),
          label: 'Edit',
        },
      ],
    }

    return <ActionMenu menu={menu} placement="top" />
  }

  return <div />
}

const columns: ColDef[] = [
  textColDef(TextCellRenderer, {
    field: 'version_name',
    headerName: 'Build number',
    resizable: false,
    suppressMovable: true,
    suppressNavigable: true,
  }),
  textColDef(TextCellRenderer, {
    field: 'bundle_id',
    headerName: 'Build ID',
    suppressMovable: true,
    suppressNavigable: true,
    width: 200,
  }),
  {
    cellRenderer: DeviceTypeCellRenderer,
    field: 'device_type',
    headerName: 'Device type',
    resizable: false,
    suppressMovable: true,
    suppressNavigable: true,
    width: 120,
  },
  badgeColDef(BadgeCellRenderer, {
    field: 'tags',
    filterValueGetter: ({ data }: ValueGetterParams<IAppBuild>) => data?.tags,
    headerName: 'Tags',
    headerTooltip: 'Tags',
    valueGetter: ({ data }: ValueGetterParams<IAppBuild>) => {
      const { tags } = data as IAppBuild

      return {
        data:
          tags?.map((tag) => ({
            id: tag,
            name: capitalize(tag),
          })) || [],
        type: 'build',
      }
    },
  }),
  textColDef(TextCellRenderer, {
    field: 'description',
    headerName: 'Description',
    suppressMovable: true,
  }),
  dateIsoColDef({
    field: 'created_at',
    headerName: 'Date',
    headerTooltip: 'Date',
  }),
  actionsColDef(ActionsCellRenderer, {
    field: 'actions',
  }),
]

export default columns
